import { useTheme } from '@mui/material/styles';
import { UserStatus } from 'src/@types/user-status';
import { StyledBadgeStatus } from './styles';
import { BadgeStatusProps } from './types';

export default function BadgeStatus({
  size = 'medium',
  status = UserStatus.OFFLINE,
  sx,
}: BadgeStatusProps) {
  const theme = useTheme();

  return (
    <StyledBadgeStatus ownerState={{ status, size }} sx={sx} theme={theme} />
  );
}
